import { createSlice } from '@reduxjs/toolkit';
import { set } from './utils/objectHelpers';

const initialState = {
  theme: undefined,
  components: undefined,
  site: undefined,
  isStyleChanged: false,
  editor: {
    mode: 'edit',
    show: false,
    add: 'last',
    edit: undefined,
  },
};

const { reducer, actions } = createSlice({
  name: 'career-portal',
  initialState,

  reducers: {
    setTheme: (state, { payload }) => {
      state.theme = payload;
    },
    setComponents: (state, { payload }) => {
      state.components = payload;
    },
    setSite: (state, { payload }) => {
      state.site = payload;
    },
    setStyleChanged: (state, { payload }) => {
      state.isStyleChanged = payload;
    },

    setSliceValue: (state, { payload }) => {
      const { path, value } = payload;
      set(state, path, value);
    },
    setEditor: (state, { payload = initialState.editor }) => {
      state.editor = payload;
    },
    showEditComponent: (state, { payload }) => {
      state.editor.show = payload === undefined ? false : true;
      state.editor.edit = payload;
      state.editor.add = 'last';
    },
    showAddComponent: (state, { payload }) => {
      state.editor.show = true;
      state.editor.edit = undefined;
      state.editor.add = payload;
    },
    toggleThemeEditor: (state, { payload }) => {
      state.editor.show = payload;
      if (payload === true) {
        state.editor.add = 'last';
      }
    },
  },
});

export const {
  setTheme,
  setComponents,
  setSite,
  setSliceValue,
  setEditor,
  showAddComponent,
  showEditComponent,
  toggleThemeEditor,
  setStyleChanged,
} = actions;

export default reducer;
